import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBetHistoryConfigs() {
    return {
        palette: {
            [PALETTE_IDS.BET_HISTORY]: {
                BET_HISTORY_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                BET_HISTORY_DETAILS_BG: COLOR.BRAND.BACKGROUND4,

                BET_HISTORY_DETAILS_LEGS_HEADER_TEXT: {
                    fontSize: FONT.SIZE_LARGE,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_SECOND,
                },
            },
        },
    };
}
